const importantizeClasses = (className: string) =>
  `!${className.split(' ').join(' !')}`;

const scopedClassName = (scope: string, className: string) =>
  className
    .split(' ')
    .map((token) => `${scope}:${token.replace(/^!/, '')}`)
    .join(' ');

export const stackedFieldLabelClassName =
  'font-medium uppercase tracking-[0.12em] text-secondary-500 text-[9px]';

export const stackedFieldValueClassName = '!font-medium';

export const stackedFieldContentClassName = 'px-2.5';

export const stackedFieldButtonClassName = [
  'w-full',
  'justify-between',
  '!gap-0',
  importantizeClasses(stackedFieldContentClassName),
  '[&_.truncate]:!font-medium',
  '[&_.truncate]:!leading-normal',
].join(' ');

export const stackedFieldTriggerClassName = stackedFieldButtonClassName;

export const stackedFieldScopeClassName = [
  scopedClassName('[&_.stacked-field-label]', stackedFieldLabelClassName),
  '[&_.stacked-field-control]:!w-full',
  '[&_.stacked-field-control]:!max-w-none',
  '[&_.stacked-field-control]:!justify-between',
  '[&_.stacked-field-control]:!px-2.5',
  scopedClassName('[&_.stacked-field-control]', stackedFieldValueClassName),
  '[&_.stacked-field-select-trigger]:!w-full',
  '[&_.stacked-field-select-trigger]:!justify-between',
  '[&_.stacked-field-select-trigger]:!px-2.5',
  scopedClassName(
    '[&_.stacked-field-select-trigger]',
    stackedFieldValueClassName
  ),
  scopedClassName(
    '[&_.stacked-field-control_.truncate]',
    stackedFieldValueClassName
  ),
  scopedClassName(
    '[&_.stacked-field-select-trigger_.truncate]',
    stackedFieldValueClassName
  ),
].join(' ');
